<template>
  <el-dialog :close-on-click-modal="false" :visible="visible" title="定点医药机构信息查询" append-to-body width="80rem" @open="open" @close="close">
    <div>
      <div class="views-search left-pad">
        <el-form ref="searchForm" label-width="0" size="small" :rules="rules" label-position="right" :model="condition">
          <div style="display:flex;">
            <!--<el-form-item>
              <dict-select size="small" v-model="medCode" isMed dict-type="med_code" placeholder="定点区划" class="edit-input" />
            </el-form-item>-->
            <el-form-item class="left-pad" prop="fixmedins_type">
              <dict-select size="small" v-model="condition.fixmedins_type" isMed dict-type="fixmedins_type" placeholder="定点机构类型" :disabled="!!fixmedinsType" />
            </el-form-item>
            <el-form-item class="left-pad" prop="fixmedins_code">
              <el-input v-model="condition.fixmedins_name" placeholder="定点医药机构名称" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item class="left-pad" prop="fixmedins_code">
              <el-input v-model="condition.fixmedins_code" placeholder="定点医药机构编号" size="small" clearable></el-input>
            </el-form-item>
            <div>
              <el-button type="primary" size="small" icon="el-icon-search" class="left-pad" :loading="loading" @click="handleSearch">查询</el-button>
              <el-button type="primary" size="small" icon="el-icon-finished" class="left-pad" @click="select">选择</el-button>
              <span class="left-pad" v-if="selectItem">当前选中：{{selectItem.fixmedins_name}}</span>
            </div>
          </div>
        </el-form>
      </div>

      <div class="views-table">
        <el-table :data="result.medinsinfo" v-loading="loading" highlight-current-row @current-change="currentChange" @row-dblclick="rowDblclick" style="width: 100%" height="100%" class="main-table">
          <el-table-column prop="fixmedins_code" label="定点医药机构编号"></el-table-column>
          <el-table-column prop="fixmedins_name" label="定点医药机构名称"></el-table-column>
          <el-table-column prop="uscc" label="统一社会信用代码"></el-table-column>
          <el-table-column prop="fixmedins_type" label="定点医疗服务机构类型">
            <template slot-scope="{row}">
              {{row.fixmedins_type | dictText('fixmedins_type')}}
            </template>
          </el-table-column>
          <el-table-column prop="hosp_lv" label="医院等级"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/common/api';

export default {
  name: 'med-hospital',
  props: {
    visible: { type: Boolean, default: false },
    fixmedinsType: { type: String, default: null },
    fixmedinsName: { type: String, default: null },
    fixmedinsCode: { type: String, default: null },
  },
  data () {
    return {
      // medCode: this.$store.state.medCode,
      loading: false,
      rules: {
        fixmedins_code: [{ validator: this.validateName, trigger: 'blur' }]
      },
      condition: {
        fixmedins_type: '1',
        fixmedins_name: '',
        fixmedins_code: ''
      },
      result: {
        medinsinfo: []
      },
      selectItem: null
    };
  },
  methods: {
    open () {
      this.selectItem = null
      this.condition.fixmedins_name = this.fixmedinsName
      this.condition.fixmedins_code = this.fixmedinsCode
      this.condition.fixmedins_type = this.fixmedinsType
      if (this.fixmedinsName || this.fixmedinsCode) {
        this.$nextTick(() => {
          this.handleSearch()
        })
      }
    },
    close () {
      this.$emit('update:visible', false)
    },
    validateName (rule, value, callback) {
      if (!value && !this.condition.fixmedins_name) {
        callback(new Error('名称、编号至少必填一个！'));
      } else {
        callback();
      }
    },
    handleSearch () {
      this.$refs.searchForm.validate().then(valid => {
        this.loading = true
        return api.exec('1201', { medinsinfo: this.condition })
      }).then(({output: res}) => {
        this.result = res;
      }).finally(() => this.loading = false);
    },
    rowDblclick (row) {
      if (row) {
        this.selectItem = row
        this.select()
      }
    },
    currentChange (currentRow, oldCurrentRow) {
      if (currentRow) {
        this.selectItem = currentRow
      }
    },
    select () {
      if (!this.selectItem) return;
      this.$emit('update:fixmedinsName', this.selectItem.fixmedins_name)
      this.$emit('update:fixmedinsCode', this.selectItem.fixmedins_code)
      this.close()
    }
  },
};
</script>
